<script>
  import LandSelect from "./LandSelect.svelte";
  import {
    find_help_text_if_exists,
    getLastDayOfMonth,
    month_to_number,
    number_to_month,
    percentage_math,
    remove_dataimport_except_when_opportunity,
  } from "./Utils.svelte";
  import { onMount } from "svelte";
  import Chart1MarketBubbles from "./Chart1MarketBubbles.svelte";

  import MarketProgressReportNewLeads from "./MarketProgressReportNewLeads.svelte";
  import MarketProgressReportTableNewLeads from "./MarketProgressReportTableNewLeads.svelte";
  import MarketProgressReportActiveBoli from "./MarketProgressReportActiveBoli.svelte";
  import MarketProgressReportTableActiveBoli from "./MarketProgressReportTableActiveBoli.svelte";

  import {
    add_boli_churn,
    add_thereof_new_boli,
    aufsummieren,
    calc_activated_all_removed_not_new_cust_boli,
    calc_active_boli_per_country_per_month,
    calc_active_customers_per_month,
    calc_balken_progress_table_active_boli_from_events_per_country_per_month,
    calc_balken_progress_table_active_boli_per_country,
    calc_balken_progress_table_herd_churn_per_country_per_month,
    calc_balken_progress_table_lost_boli_per_country,
    calc_balken_progress_table_lost_boli_per_country_per_month,
    calc_balken_progress_table_lost_clients_per_country,
    calc_fields_from_animals_table_per_country_per_month,
    calc_management_clients_per_country_per_month,
    calc_management_leads_per_country_per_month,
    calc_management_opportunities_per_country_per_month,
    calc_management_sold_boli_per_country_per_month,
    calc_months_last_year_array,
    calc_open_leads_per_country,
    calc_open_opps_per_country,
    country_month_to_median,
    dateRange,
    dict_to_sum,
    dict_to_sum_2d,
    filter_messenger_res_group_by_partner_only_herdsize,
    get_anteilsmaessig_date_filter_range,
    get_last_value_if_not_very_small,
    remove_deactivated_from_basis,
    subtract_country_month_dicts,
    sum_up_months_from_country,
  } from "./UtilsBalkenProgress.svelte";

  export let show_main_content = false;
  export let laender_dict;

  export let marketing_team;
  export let crm_lead_all;
  export let lost_leads;
  export let lost_opportunities;
  export let marketing_goals;
  export let messenger_res;
  export let archived;
  export let res_partner_all;
  export let sale_order_all;
  export let subscription_all;
  export let activated_all;
  export let helptexts;
  export let in_show_helptext_id;

  let crm_lead_all_without_data_import;
  let lost_leads_without_data_import;
  let lost_opportunities_without_data_import;
  let archived_without_data_import;

  let ytd_active = true;
  let filter_active = false;

  let table_leads_dict;
  let table_leads_dict_basis;

  let new_boli_new_customers;

  let active_animals_table_values;
  let active_customers_per_month;

  let laender_dict_targets = false;
  let adressable_market_size_charts_dict = false;
  let acq_cost_dict = {};
  let cost_per_new_customer = 0;
  let cost_per_new_cow = 0;
  let average_herd_size = {};
  let acq_cost;
  let acq_cost_helper;

  let active_boluses_per_customer = {};

  export let marketing_start_date = new Date(new Date().getFullYear(), 0, 1);
  export let marketing_end_date = new Date();
  let months = [];

  let market_target_if_not_defined_in_odoo = 0;

  let radius_biggest_country = 50;

  let lead_or_boli_1 = 3;
  let lead_or_boli_2 = 1;

  export let date_start_string_month = "Jan";
  export let date_end_string_month = number_to_month(new Date().getMonth());
  export let date_start_string_year = new Date().getFullYear().toString();
  export let date_end_string_year = new Date().getFullYear().toString();

  let balken_leads_opps_cust_boli;

  let open_leads_per_country;
  let open_opps_per_country;

  let herd_churn_per_country;

  let lost_boli_per_country_per_month;
  let active_boli_per_month_per_country;
  let table_active_boli_deactivated_animals_per_country;
  let table_active_boli_deactivated_animals_per_country_pre_month;
  let active_boli_basis_per_country;
  let animals_table_values;
  let animals_table_values_basis;

  let new_leads_target = 0;

  let leads_per_country_per_month;

  let sold_boli_target;

  let act_market_share_per_country;
  let customer_churn;
  let table_sold_boli_dict_per_country;
  let lost_boli_per_country;
  let boli_odoo_table;

  let active_boli_end_of_timeframe = false;

  let market_progress_rep_table_active_boli_basis = {
    AT: 5000,
    DE: 10000,
  };

  let mprt_countries_dict = {
    AT: {
      "Active Boluses": {
        "2022-01": 8177,
        "2022-02": 5331,
        "2022-03": 3511,
        "2022-04": 8777,
        "2022-05": 4653,
        "2022-06": 8127,
        "2022-07": 8657,
        "2022-08": 8890,
        "2022-09": 7546,
        "2022-10": 7852,
        "2022-11": 7952,
      },

      "New active boli": {
        "2022-01": 8177,
        "2022-02": 5331,
        "2022-03": 3511,
        "2022-04": 8777,
        "2022-05": 4653,
        "2022-06": 8127,
        "2022-07": 8657,
        "2022-08": 8890,
        "2022-09": 7546,
        "2022-10": 7852,
        "2022-11": 7952,
      },

      "> thereof remont": {
        "2022-01": 8177,
        "2022-02": 5331,
        "2022-03": 3511,
        "2022-04": 8777,
        "2022-05": 4653,
        "2022-06": 8127,
        "2022-07": 8657,
        "2022-08": 8890,
        "2022-09": 7546,
        "2022-10": 7852,
        "2022-11": 7952,
      },

      "> thereof new boli": {
        "2022-01": 8177,
        "2022-02": 5331,
        "2022-03": 3511,
        "2022-04": 8777,
        "2022-05": 4653,
        "2022-06": 8127,
        "2022-07": 8657,
        "2022-08": 8890,
        "2022-09": 7546,
        "2022-10": 7852,
        "2022-11": 7952,
      },

      Churn: {
        "2022-01": 8177,
        "2022-02": 5331,
        "2022-03": 3511,
        "2022-04": 8777,
        "2022-05": 4653,
        "2022-06": 8127,
        "2022-07": 8657,
        "2022-08": 8890,
        "2022-09": 7546,
        "2022-10": 7852,
        "2022-11": 7952,
      },
    },
    DE: {
      "Active Boluses": {
        "2022-01": 8177,
        "2022-02": 5331,
        "2022-03": 3511,
        "2022-04": 8777,
        "2022-05": 4653,
        "2022-06": 8127,
        "2022-07": 8657,
        "2022-08": 8890,
        "2022-09": 7546,
        "2022-10": 7852,
        "2022-11": 7952,
      },

      "New active boli": {
        "2022-01": 8177,
        "2022-02": 5331,
        "2022-03": 3511,
        "2022-04": 8777,
        "2022-05": 4653,
        "2022-06": 8127,
        "2022-07": 8657,
        "2022-08": 8890,
        "2022-09": 7546,
        "2022-10": 7852,
        "2022-11": 7952,
      },

      "> thereof remont": {
        "2022-01": 8177,
        "2022-02": 5331,
        "2022-03": 3511,
        "2022-04": 8777,
        "2022-05": 4653,
        "2022-06": 8127,
        "2022-07": 8657,
        "2022-08": 8890,
        "2022-09": 7546,
        "2022-10": 7852,
        "2022-11": 7952,
      },

      "> thereof new boli": {
        "2022-01": 8177,
        "2022-02": 5331,
        "2022-03": 3511,
        "2022-04": 8777,
        "2022-05": 4653,
        "2022-06": 8127,
        "2022-07": 8657,
        "2022-08": 8890,
        "2022-09": 7546,
        "2022-10": 7852,
        "2022-11": 7952,
      },

      Churn: {
        "2022-01": 8177,
        "2022-02": 5331,
        "2022-03": 3511,
        "2022-04": 8777,
        "2022-05": 4653,
        "2022-06": 8127,
        "2022-07": 8657,
        "2022-08": 8890,
        "2022-09": 7546,
        "2022-10": 7852,
        "2022-11": 7952,
      },
    },
  };

  let mprt_basis_dict = {
    AT: 5000,
    DE: 10000,
  };

  let countdown_first_dollar = 3;

  $: {
    // marketing_start_date, marketing_end_date, laender_dict;
    marketing_start_date;
    marketing_end_date;
    laender_dict;

    if (
      crm_lead_all_without_data_import &&
      lost_leads_without_data_import &&
      lost_opportunities_without_data_import &&
      archived_without_data_import
    ) {
      if (marketing_start_date && marketing_end_date && laender_dict) {
        if (countdown_first_dollar > 0) {
          countdown_first_dollar = countdown_first_dollar - 1;
        } else {
          if (marketing_start_date <= marketing_end_date) {
            do_all_management_calculations();
          } else {
            alert("Start Date after End Date");
          }
        }
      }
    }
  }

  $: {
    marketing_team, crm_lead_all, lost_leads, lost_opportunities, marketing_goals, archived, messenger_res;

    if (marketing_team && crm_lead_all && lost_leads && lost_opportunities && marketing_goals && archived && messenger_res) {
      let tmp_without_data_import = remove_dataimport_except_when_opportunity(crm_lead_all, lost_leads, lost_opportunities, archived);

      crm_lead_all_without_data_import = tmp_without_data_import["crm_lead_all"];
      lost_leads_without_data_import = tmp_without_data_import["lost_leads"];
      lost_opportunities_without_data_import = tmp_without_data_import["lost_opportunities"];
      archived_without_data_import = tmp_without_data_import["archived"];

      console.log("Management Daten geladen");
      do_all_management_calculations();
    }
  }

  function set_calendar_gui() {
    if (jSuites && "calendar" in jSuites) {
      // console.log("jSuites: ", jSuites)
      // var calendar3 = jSuites.calendar(document.getElementById('calendar3'), {});
      // console.log("calendar3: ", calendar3)
      // console.log("marketing_start_date: ", marketing_start_date)
      // calendar3.setValue(marketing_start_date);
      // var calendar4 = jSuites.calendar(document.getElementById('calendar4'), {});
      // calendar4.setDate(marketing_end_date);
      // console.log("Set Kalendar")
    }
  }

  function calc_all_months_array() {
    var months = dateRange(new Date(2016, 0, 1), new Date());

    return months;
  }

  function do_all_management_calculations() {
    console.log("do_all_management_calculations");
    calc_months_array();

    let months_all = calc_all_months_array();
    calc_targets();

    let messenger_res_only_with_charged_animals = filter_messenger_res_group_by_partner_only_herdsize(messenger_res);

    let tmp_1 = calc_active_customers_per_month(months_all, laender_dict, res_partner_all, messenger_res_only_with_charged_animals, months);

    active_customers_per_month = tmp_1["ret_dict"];
    let active_customers = tmp_1["active_customers"];

    active_customers = get_last_value_if_not_very_small(active_customers, laender_dict, months, months_all);

    // filter_all_leads_and_opportunities();
    calc_balken_leads_opps_cust_boli();

    active_boli_per_month_per_country = calc_balken_progress_table_active_boli_from_events_per_country_per_month(
      months,
      activated_all,
      marketing_start_date,
      marketing_end_date,
      laender_dict,
    );

    table_active_boli_deactivated_animals_per_country = calc_balken_progress_table_active_boli_from_events_per_country_per_month(
      months,
      activated_all,
      marketing_start_date,
      marketing_end_date,
      laender_dict,
      "deactivated_",
    );

    act_market_share_per_country = calc_active_boli_per_country_per_month(
      messenger_res,
      months,
      laender_dict,
      marketing_start_date,
      marketing_end_date,
    );

    animals_table_values = calc_fields_from_animals_table_per_country_per_month(
      messenger_res,
      months,
      laender_dict,
      marketing_start_date,
      marketing_end_date,
      ["remounted_animals", "inactive_animals", "new_animals", "qty"],
    );

    //active_boli_per_month_per_country

    add_thereof_new_boli(animals_table_values, laender_dict, months);
    add_boli_churn(animals_table_values, lost_boli_per_country_per_month, laender_dict, months);

    animals_table_values["active_animals_events"] = subtract_country_month_dicts(
      active_boli_per_month_per_country,
      table_active_boli_deactivated_animals_per_country,
    );

    animals_table_values["increase"] = active_boli_per_month_per_country;
    animals_table_values["decrease"] = table_active_boli_deactivated_animals_per_country;

    animals_table_values_basis = calc_fields_from_animals_table_per_country_per_month(
      messenger_res,
      months,
      laender_dict,
      marketing_start_date,
      marketing_end_date,
      ["remounted_animals", "inactive_animals", "new_animals", "qty"],
      true,
    );

    lost_boli_per_country_per_month = calc_balken_progress_table_lost_boli_per_country_per_month(
      months,
      res_partner_all,
      subscription_all,
      laender_dict,
    );

    var activated_all_removed_not_new_cust_boli = calc_activated_all_removed_not_new_cust_boli(activated_all);
    new_boli_new_customers = calc_balken_progress_table_active_boli_from_events_per_country_per_month(
      months,
      activated_all_removed_not_new_cust_boli,
      marketing_start_date,
      marketing_end_date,
      laender_dict,
    );

    var pre_month = new Date(marketing_start_date);
    pre_month.setMonth(pre_month.getMonth() - 1);
    var pre_months = calc_months_last_year_array(new Date(2016, 1, 1), pre_month);

    table_active_boli_deactivated_animals_per_country_pre_month = calc_balken_progress_table_active_boli_from_events_per_country_per_month(
      pre_months,
      activated_all,
      marketing_start_date,
      marketing_end_date,
      laender_dict,
      "deactivated_",
    );

    active_boli_basis_per_country = calc_balken_progress_table_active_boli_from_events_per_country_per_month(
      pre_months,
      activated_all,
      marketing_start_date,
      marketing_end_date,
      laender_dict,
    );

    remove_deactivated_from_basis(
      pre_months,
      laender_dict,
      active_boli_basis_per_country,
      table_active_boli_deactivated_animals_per_country_pre_month,
    );

    // FUnktion subtrahiert nur dicts und kann also auch hierfür verwendet werden
    remove_deactivated_from_basis(months, laender_dict, active_boli_per_month_per_country, new_boli_new_customers);
    remove_deactivated_from_basis(months, laender_dict, table_active_boli_deactivated_animals_per_country, lost_boli_per_country_per_month);

    aufsummieren(animals_table_values["active_animals_events"], active_boli_basis_per_country, months, laender_dict);

    var herd_churn_per_country_per_month = calc_balken_progress_table_herd_churn_per_country_per_month(
      months,
      res_partner_all,
      subscription_all,
      laender_dict,
    );

    herd_churn_per_country = sum_up_months_from_country(herd_churn_per_country_per_month, laender_dict, months);

    active_animals_table_values = {};
    active_animals_table_values["Active Boluses"] = animals_table_values["active_animals_events"];
    active_animals_table_values["New boli (new customers)"] = new_boli_new_customers;
    active_animals_table_values["Increase"] = active_boli_per_month_per_country;
    active_animals_table_values["Decrease"] = table_active_boli_deactivated_animals_per_country;
    active_animals_table_values["Boli churn"] = lost_boli_per_country_per_month;
    active_animals_table_values["Herd churn"] = herd_churn_per_country_per_month;

    calc_adressable_market_size_charts();
    calc_land_eintrag_radius();

    cost_per_new_customer = acq_cost_helper / balken_leads_opps_cust_boli["Total"][2];

    cost_per_new_cow = acq_cost_helper / dict_to_sum_2d(active_animals_table_values["New boli (new customers)"]);

    let active_boli_per_country_sum = 0;

    laender_dict.forEach((land_eintrag) => {
      let active_boli_per_country =
        -dict_to_sum(table_active_boli_deactivated_animals_per_country[land_eintrag["long"]]) -
        dict_to_sum(lost_boli_per_country_per_month[land_eintrag["long"]]) +
        dict_to_sum(new_boli_new_customers[land_eintrag["long"]]) +
        dict_to_sum(active_boli_per_month_per_country[land_eintrag["long"]]) +
        dict_to_sum(active_boli_basis_per_country[land_eintrag["long"]]);

      active_boli_per_country_sum += active_boli_per_country;

      // console.log("land_eintrag['long']: ", land_eintrag['long'])
      // console.log("active_boli_per_country: ", active_boli_per_country)
      // console.log("active_customers[land_eintrag['long']]: ", active_customers[land_eintrag['long']])

      active_boluses_per_customer[land_eintrag["long"]] = active_boli_per_country / active_customers[land_eintrag["long"]];
    });
    active_boluses_per_customer["Total"] = active_boli_per_country_sum / active_customers["Total"];
  }

  function calc_land_eintrag_radius() {
    var find_biggest_country = 0;

    laender_dict.forEach((land) => {
      if (laender_dict_targets[land["short"]]["AMS"] > find_biggest_country) {
        find_biggest_country = laender_dict_targets[land["short"]]["AMS"];
      }
    });

    for (var i = 0; i < laender_dict.length; i += 1) {
      // laender_dict[i]['radius'] = laender_dict_targets[laender_dict[i]['short']]['AMS'] * radius_factor
      laender_dict[i]["radius"] =
        (0.3 + Math.log(1 + laender_dict_targets[laender_dict[i]["short"]]["AMS"] / find_biggest_country)) * radius_biggest_country;
    }
  }

  function calc_adressable_market_size_charts() {
    var tmp_dict = {};
    var tmp_active_boli_end_of_timeframe = {};

    laender_dict.forEach((land) => {
      tmp_dict[land["short"]] = {
        AMS_percentage: 0,
        AMT_percentage: 0,
      };
    });

    var total_ams = 0;
    var total_ams_farms = 0;
    var total_tms = 0;
    var total_active_boli = 0;

    laender_dict.forEach((land) => {
      if (!land["checked"]) {
        return;
      }

      var active_boli = 0;

      months.forEach((m) => {
        var active_boli_in_month = active_animals_table_values["Active Boluses"][land["long"]][m];

        if (active_boli_in_month > 0) {
          active_boli = active_boli_in_month;
        }
      });

      tmp_active_boli_end_of_timeframe[land["short"]] = active_boli;

      total_active_boli += active_boli;
      if ("AMS" in laender_dict_targets[land["short"]]) {
        total_ams += laender_dict_targets[land["short"]]["AMS"];
      }
      if ("AMT" in laender_dict_targets[land["short"]]) {
        total_tms += laender_dict_targets[land["short"]]["AMT"];
      }
      if ("AMS_Farms" in laender_dict_targets[land["short"]]) {
        // console.log("laender_dict_targets[land['short']]['AMS_Farms']: ", laender_dict_targets[land['short']]['AMS_Farms'])
        total_ams_farms += laender_dict_targets[land["short"]]["AMS_Farms"];
      }
      tmp_dict[land["short"]]["AMS_percentage"] = percentage_math(active_boli, laender_dict_targets[land["short"]]["AMS"]).toFixed(1);

      if (isNaN(tmp_dict[land["short"]]["AMS_percentage"])) {
        tmp_dict[land["short"]]["AMS_percentage"] = 0;
      }

      tmp_dict[land["short"]]["AMT_percentage"] = percentage_math(
        laender_dict_targets[land["short"]]["AMT"],
        laender_dict_targets[land["short"]]["AMS"],
      ).toFixed(1);

      if (isNaN(tmp_dict[land["short"]]["AMT_percentage"])) {
        tmp_dict[land["short"]]["AMT_percentage"] = 0;
      }
    });

    laender_dict_targets["Total"] = {
      AMS: total_ams,
      AMT: total_tms,
      AMS_Farms: total_ams_farms,
    };

    tmp_dict["Total"] = {
      AMS_percentage: percentage_math(total_active_boli, total_ams).toFixed(1),
      AMT_percentage: percentage_math(total_tms, total_ams).toFixed(1),
    };

    tmp_active_boli_end_of_timeframe["Total"] = total_active_boli;

    adressable_market_size_charts_dict = tmp_dict;
    active_boli_end_of_timeframe = tmp_active_boli_end_of_timeframe;
  }

  function calc_targets() {
    var tmp_dict = {};

    laender_dict.forEach((land) => {
      tmp_dict[land["short"]] = {};
    });

    new_leads_target = 0;
    sold_boli_target = {};
    acq_cost_helper = 0;

    marketing_goals.forEach((goal) => {
      if (goal["challenge_name"].includes("AMS ")) {
        if (goal["goal_name"].includes("Cows")) {
          tmp_dict[goal["challenge_name"].split(" ")[1]]["AMS"] = goal["target_goal"]
            ? goal["target_goal"]
            : market_target_if_not_defined_in_odoo;
        }
      }

      if (goal["challenge_name"].includes("AMS ")) {
        if (goal["goal_name"].includes("farms")) {
          tmp_dict[goal["challenge_name"].split(" ")[1]]["AMS_Farms"] = goal["target_goal"]
            ? goal["target_goal"]
            : market_target_if_not_defined_in_odoo;
          // console.log("FarmGoal: ", goal['target_goal'])
        }
      }

      if (goal["challenge_name"].includes("AMT ")) {
        if (goal["start_date"].substring(0, 4) == marketing_end_date.getFullYear().toString()) {
          tmp_dict[goal["challenge_name"].split(" ")[1]]["AMT"] = goal["target_goal"]
            ? goal["target_goal"]
            : market_target_if_not_defined_in_odoo;
        }
      }

      let filter_end = marketing_end_date;

      if (ytd_active) {
        filter_end = getLastDayOfMonth(new Date());
      }

      if (goal["challenge_name"].includes("ACQCost") && goal["start_date"].substring(0, 4) == marketing_start_date.getFullYear()) {
        acq_cost = goal["target_goal"];
      }

      if (
        goal["challenge_name"].includes("ACQCost") &&
        parseInt(goal["start_date"].substring(0, 4)) >= marketing_start_date.getFullYear() &&
        parseInt(goal["start_date"].substring(0, 4)) <= marketing_end_date.getFullYear()
      ) {
        // acq_cost_helper += goal['target_goal']
        acq_cost_helper += get_anteilsmaessig_date_filter_range(goal, months, marketing_start_date, filter_end);
      }

      // acq_cost_helper

      if (goal["challenge_name"].includes("LEAD_TARGET")) {
        new_leads_target += get_anteilsmaessig_date_filter_range(goal, months, marketing_start_date, filter_end);
      }

      if (
        goal["name"] == "SOLD_BOL_TARGET 2023 MKT" ||
        goal["name"] == "SOLD_BOL_TARGET 2022 MKT" ||
        goal["name"] == "SOLD_BOL_TARGET 2021 MKT"
      ) {
        return;
      }

      if (goal["challenge_name"].includes("SOLD_BOL_TARGET")) {
        var country_short = goal["name"].split("MKT_")[1].split("_")[0];
        if (country_short in sold_boli_target) {
          sold_boli_target[country_short] += get_anteilsmaessig_date_filter_range(goal, months, marketing_start_date, filter_end);
        } else {
          sold_boli_target[country_short] = get_anteilsmaessig_date_filter_range(goal, months, marketing_start_date, filter_end);
        }
      }
    });

    laender_dict_targets = tmp_dict;
  }

  function update_date_filter() {
    console.log("date_start_string_month: ", date_start_string_month);
    set_calendar_gui();

    var date_start = new Date(parseInt(date_start_string_year), month_to_number(date_start_string_month), 1, 0, 0, 0);
    var date_end = new Date(parseInt(date_end_string_year), month_to_number(date_end_string_month) + 1, 0, 23, 59);

    marketing_start_date = date_start;
    marketing_end_date = date_end;

    ytd_active = false;
    filter_active = true;

    calc_months_array();
  }

  function calc_months_array() {
    months = dateRange(marketing_start_date, marketing_end_date);
  }

  // function filter_all_leads_and_opportunities() {
  //   lost_leads_without_data_import_filtered = [];
  //   crm_lead_all_without_data_import_filtered = [];
  //   lost_opportunities_without_data_import_filtered = [];
  //   archived_without_data_import_filtered = [];

  //   let country_list_tmp = [];

  //   lost_leads_without_data_import.forEach((element) => {
  //     if (element['source_category'] != 'Sales') {
  //       if (!get_country_checked(element['country'], laender_dict)) {
  //         return;
  //       }

  //       var create_date = new Date(element['x_date_creation']);
  //       if (create_date >= marketing_start_date && create_date <= marketing_end_date) {
  //         lost_leads_without_data_import_filtered.push(element);
  //       }
  //     }
  //   });

  //   crm_lead_all_without_data_import.forEach((element) => {
  //     if (element[1]['source_category'] != 'Sales') {
  //       if (!get_country_checked(element[1]['country'], laender_dict)) {
  //         return;
  //       }

  //       var create_date = new Date(element[1]['create_date']);
  //       if (create_date >= marketing_start_date && create_date <= marketing_end_date) {
  //         crm_lead_all_without_data_import_filtered.push(element[1]);
  //       }
  //     }
  //   });

  //   lost_opportunities_without_data_import.forEach((element) => {
  //     if (element['source_category'] != 'Sales') {
  //       if (!get_country_checked(element['country'], laender_dict)) {
  //         return;
  //       }

  //       var create_date = new Date(element['x_date_creation']);
  //       if (create_date >= marketing_start_date && create_date <= marketing_end_date) {
  //         lost_opportunities_without_data_import_filtered.push(element);
  //       }
  //     }
  //   });

  //   archived_without_data_import.forEach((element) => {
  //     if (element[1]['source_category'] != 'Sales') {
  //       if (!get_country_checked(element[1]['x_country_id'][1], laender_dict)) {
  //         return;
  //       }

  //       var create_date = new Date(element[1]['x_date_creation']);
  //       if (create_date >= marketing_start_date && create_date <= marketing_end_date) {
  //         archived_without_data_import_filtered.push(element[1]);
  //       }
  //     }
  //   });

  //   // console.log('country_list_tmp: ', country_list_tmp);
  // }

  function calc_balken_leads_opps_cust_boli() {
    table_leads_dict = calc_management_leads_per_country_per_month(
      months,
      laender_dict,
      lost_leads_without_data_import,
      crm_lead_all_without_data_import,
      lost_opportunities_without_data_import,
      archived_without_data_import,
      marketing_start_date,
      marketing_end_date,
    );

    table_leads_dict_basis = country_month_to_median(
      calc_management_leads_per_country_per_month(
        months,
        laender_dict,
        lost_leads_without_data_import,
        crm_lead_all_without_data_import,
        lost_opportunities_without_data_import,
        archived_without_data_import,
        marketing_start_date,
        marketing_end_date,
        true,
      ),
    );

    leads_per_country_per_month = table_leads_dict;

    let table_clients_dict = calc_management_clients_per_country_per_month(months, laender_dict, res_partner_all, laender_dict);

    let table_sold_boli_dict = calc_management_sold_boli_per_country_per_month(
      months,
      laender_dict,
      sale_order_all,
      marketing_start_date,
      marketing_end_date,
    );

    var tmp_dict = {};
    laender_dict.forEach((l) => {
      if (l["checked"]) {
        tmp_dict[l["long"]] = dict_to_sum(table_sold_boli_dict[l["long"]]);
      }
    });
    tmp_dict["Total"] = dict_to_sum(tmp_dict);
    table_sold_boli_dict_per_country = tmp_dict;

    let table_opportunities = calc_management_opportunities_per_country_per_month(
      months,
      laender_dict,
      lost_leads_without_data_import,
      crm_lead_all_without_data_import,
      lost_opportunities_without_data_import,
      archived_without_data_import,
      marketing_start_date,
      marketing_end_date,
    );

    //balken_leads_opps_cust_boli

    balken_leads_opps_cust_boli = country_months_to_balken_leads_opps_cust_boli(
      laender_dict,
      table_leads_dict,
      table_clients_dict,
      table_sold_boli_dict,
      table_opportunities,
    );

    acq_cost_dict = calc_acq_cost_per_country(table_sold_boli_dict);

    open_leads_per_country = calc_open_leads_per_country(
      months,
      laender_dict,
      crm_lead_all_without_data_import,
      marketing_start_date,
      marketing_end_date,
    );

    open_opps_per_country = calc_open_opps_per_country(
      months,
      laender_dict,
      crm_lead_all_without_data_import,
      marketing_start_date,
      marketing_end_date,
    );

    customer_churn = calc_balken_progress_table_lost_clients_per_country(months, res_partner_all, subscription_all, laender_dict);

    boli_odoo_table = calc_balken_progress_table_active_boli_per_country(
      months,
      messenger_res,
      marketing_start_date,
      marketing_end_date,
      laender_dict,
    );

    lost_boli_per_country = calc_balken_progress_table_lost_boli_per_country(months, res_partner_all, subscription_all, laender_dict);

    lost_boli_per_country_per_month = calc_balken_progress_table_lost_boli_per_country_per_month(
      months,
      res_partner_all,
      subscription_all,
      laender_dict,
    );
  }

  function calc_acq_cost_per_country(table_sold_boli_dict) {
    let tmp_dict = {};

    var total_sold_boli = 0;

    laender_dict.forEach((l) => {
      total_sold_boli += dict_to_sum(table_sold_boli_dict[l["long"]]);
    });

    laender_dict.forEach((l) => {
      dict_to_sum(table_sold_boli_dict[l["long"]]);

      //Alt: Gesamtkosten pro Land
      // tmp_dict[l['short']] = acq_cost * (sum_of_sold_boli_of_country/total_sold_boli)

      //Neu: Kosten pro Kuh
      tmp_dict[l["short"]] = acq_cost / total_sold_boli;
    });

    tmp_dict["Total"] = acq_cost;

    return tmp_dict;
  }

  function set_ytd() {
    marketing_start_date = new Date(new Date().getFullYear(), 0, 1);
    marketing_end_date = new Date();
    calc_months_array();
    ytd_active = true;
    filter_active = false;
  }

  function country_months_to_balken_leads_opps_cust_boli(
    laender_dict,
    table_leads_dict,
    table_clients_dict,
    table_sold_boli_dict,
    table_opportunities,
  ) {
    let ret_dict = {};

    let sum_leads = 0;
    let sum_opps = 0;
    let sum_custs = 0;
    let sum_boli = 0;

    laender_dict.forEach((c) => {
      ret_dict[c["long"]] = [
        dict_to_sum(table_leads_dict[c["long"]]),
        dict_to_sum(table_opportunities[c["long"]]),
        dict_to_sum(table_clients_dict[c["long"]]),
        dict_to_sum(table_sold_boli_dict[c["long"]]),
      ];

      sum_leads += dict_to_sum(table_leads_dict[c["long"]]);
      sum_opps += dict_to_sum(table_opportunities[c["long"]]);
      sum_custs += dict_to_sum(table_clients_dict[c["long"]]);
      sum_boli += dict_to_sum(table_sold_boli_dict[c["long"]]);
    });

    ret_dict["Total"] = [sum_leads, sum_opps, sum_custs, sum_boli];

    return ret_dict;
  }

  onMount(() => {
    jSuites.calendar(document.getElementById("calendar3"), {
      type: "year-month-picker",
      format: "MMM-YYYY",
      validRange: ["2021-01-01", "2030-12-31"],
    });
    jSuites.calendar(document.getElementById("calendar4"), {
      type: "year-month-picker",
      format: "MMM-YYYY",
      validRange: ["2021-01-01", "2030-12-31"],
    });

    // document.getElementById('calendar3').addEventListener("change", myFunction);

    // var collection = document.getElementsByClassName("jcalendar-month")[0].addEventListener("change", myFunction);

    window
      .$("#calendar3div")
      .find(".jcalendar-month")
      .on("DOMSubtreeModified", function (e) {
        //Do calculation and change value of other span2,span3 here
        date_start_string_month = e.target.outerText;
      });
    window
      .$("#calendar3div")
      .find(".jcalendar-year")
      .on("DOMSubtreeModified", function (e) {
        //Do calculation and change value of other span2,span3 here
        date_start_string_year = e.target.outerText;
      });
    window
      .$("#calendar4div")
      .find(".jcalendar-month")
      .on("DOMSubtreeModified", function (e) {
        //Do calculation and change value of other span2,span3 here
        date_end_string_month = e.target.outerText;
      });
    window
      .$("#calendar4div")
      .find(".jcalendar-year")
      .on("DOMSubtreeModified", function (e) {
        //Do calculation and change value of other span2,span3 here
        date_end_string_year = e.target.outerText;
      });

    // window.$('.jcalendar-year').on('DOMSubtreeModified', function (e) {
    //   //Do calculation and change value of other span2,span3 here
    //   console.log('CHANGE input!', e['outerText']);
    // });

    // jcalendar-input
  });
</script>

<nav class="navbar navbar-expand navbar-light navbar-bg {show_main_content === true ? 'div' : 'hiddenClass'}">
  <div class="col">
    <div class="row flex">
      <div class="row">
        <div class="col-12">
          <div class="">
            <div class="">
              <div class="row" style="height:110px;">
                <div class="col-2" style="margin-left:-20px;">
                  <b style="white-space: nowrap;">SELECTION CRITERIA&nbsp;&nbsp;&nbsp;</b>
                </div>

                <div class="col-5" style="margin-left:-70px;">
                  <table>
                    <tr>
                      <!--  <td><h5 class="card-title" style="font-size: 10px;">Select Timeframe:&nbsp; &nbsp;</h5></td> -->

                      <td style="text-align:center; width:20%;"><b>Select timeframe: </b></td>

                      <td style="text-align:center; width:10%;"
                        ><div on:click={set_ytd} class="btn {ytd_active ? 'active' : ''}">
                          <nobr>YTD {new Date().getFullYear()}</nobr>
                        </div></td
                      >

                      <td style="text-align:right; width:15%; padding-right:10px;"><b>From:</b></td>
                      <td style="text-align:center; width:15%;"
                        ><div id="calendar3div">
                          <input class="month-year" value="Jan-01" id="calendar3" style="color: black;" />
                        </div></td
                      >
                      <td style="text-align:right; width:15%; padding-right:10px;"><b>To:</b></td>
                      <td style="text-align:center; width:15%;"
                        ><div id="calendar4div">
                          <input class="month-year" id="calendar4" value="YTD" style="color: black;" />
                        </div></td
                      >
                      <td style="text-align:center; width:10%;  padding-left:10px;">
                        <div class="btn small-btn {filter_active ? 'active' : ''}" style="font-size: 10px;" on:click={update_date_filter}>
                          Filter
                        </div>
                      </td>
                    </tr>
                  </table>

                  <!-- <DatePickerText is_compare={false} bind:start_date={marketing_start_date} bind:end_date={marketing_end_date} /> -->
                </div>

                <div class="col-3 trenner-links" style="margin-left:70px;">
                  <div class="row">
                    <div class="col-1" />
                    <div class="col-10">
                      <b style="white-space: nowrap; margin-left:0px; margin-bottom:20px;">Select lead countries:</b>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-2" />
                    <div class="col-10">
                      <LandSelect bind:laender_dict />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>

<main class={show_main_content === true ? "content div" : "hiddenClass"} style="padding: 5px;">
  <div class="row haupt">
    <!-- <div class="col-md-6"><SankeyWrapper {data} /></div> -->

    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xxl-12" style="padding-top:10px">
      <div class="card h-100 green-border">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h5 class="card-title">Market status report</h5>

          <div class="info-circle my-auto">
            <div class="my-auto info-i">i</div>
            <div class="info-box" style="color: #000000;">
              {#if find_help_text_if_exists(helptexts, "management_reporting_market_status")}
                {@html find_help_text_if_exists(helptexts, "management_reporting_market_status")}
              {:else}
                <p>The Market status report provides you with market status information on selected countries.</p>
                <p>
                  The pie charts represent the markets (=countries) and show you the current market share (if you selected YTD as reporting
                  timeframe; otherwise it shows the market share at the end of the reporting timeframe) and the market share target (for end
                  of the current year / year of the reporting timeframe).
                </p>

                <p>
                  The progress bars below the pie charts show the market share relative to the market share target. The market share target
                  of the selected year represents 100%. If YTD is selected, the market share used to show the progress is the current market
                  share. If a previous year is selected, the market share at the end of the selected year is used to show the progress.
                </p>

                <p>For each market, you additionally receive information on:</p>
                <ul>
                  <li>New and open leads</li>
                  <li>New and open opportunities</li>
                  <li>New customers, customer churn</li>
                  <li>Sold BOLUSES</li>
                  <li>Active boli, boli churn, herd churn</li>
                </ul>
                <p>&nbsp;</p>
                <p>In addition, information on the following KPIs is available:</p>
                <ul>
                  <li>Cost per lead</li>
                  <li>Cow acquisition cost</li>
                </ul>
                <p>
                  <br /><span style="color: #808080;"
                    >Please note: Leads from the <strong>sales source category "data import"</strong> are only counted as &rdquo;new lead" if
                    an opportunity is created based on the lead. In this case, the lead creation date is the same as the opportunity creation
                    date.</span
                  >
                </p>
              {/if}
              {#if in_show_helptext_id}
                <div style="font-size: 7px">id: management_reporting_market_status</div>
                <div style="font-size: 7px">
                  [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                </div>
              {/if}
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row" style="width:100%;">
            <Chart1MarketBubbles
              {adressable_market_size_charts_dict}
              {laender_dict}
              {balken_leads_opps_cust_boli}
              {laender_dict_targets}
              active_boli_end_of_timeframe={active_animals_table_values["Active Boluses"]}
              {acq_cost_dict}
              {cost_per_new_customer}
              {cost_per_new_cow}
              {active_boluses_per_customer}
              {active_customers_per_month}
              {average_herd_size}
              {open_leads_per_country}
              {new_leads_target}
              {open_opps_per_country}
              {customer_churn}
              {table_sold_boli_dict_per_country}
              {boli_odoo_table}
              {lost_boli_per_country}
              {herd_churn_per_country}
              {active_animals_table_values}
              {sold_boli_target}
              {marketing_end_date}
              {marketing_start_date}
              {helptexts}
              {in_show_helptext_id}
              is_ytd={ytd_active}
            />
          </div>
          <!-- <div class="row" style="margin-top: 100px;">
            <Chart2BarDiagramLeadsOppsCustsBoli />
          </div> -->
        </div>
      </div>
    </div>

    <!-- <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xxl-12" style="padding-top:10px">
      
    </div> -->

    {#if lead_or_boli_1 == 3}
      <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xxl-12" style="padding-top: 10px">
        {#if market_progress_rep_table_active_boli_basis}
          <MarketProgressReportNewLeads
            {months}
            {laender_dict}
            {marketing_start_date}
            {marketing_end_date}
            table_data_dict={table_leads_dict}
            table_date_basis={table_leads_dict_basis}
            {adressable_market_size_charts_dict}
            {helptexts}
            {in_show_helptext_id}
            bind:lead_or_boli={lead_or_boli_1}
          />
        {/if}
      </div>
    {/if}
    {#if lead_or_boli_1 == 4}
      <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xxl-12" style="padding-top:10px">
        {#if animals_table_values_basis}
          <MarketProgressReportActiveBoli
            {months}
            {lost_boli_per_country_per_month}
            {active_boli_per_month_per_country}
            {new_boli_new_customers}
            {table_active_boli_deactivated_animals_per_country}
            {table_active_boli_deactivated_animals_per_country_pre_month}
            {active_boli_basis_per_country}
            {adressable_market_size_charts_dict}
            {laender_dict}
            {helptexts}
            {in_show_helptext_id}
            bind:lead_or_boli={lead_or_boli_1}
          />
        {/if}
      </div>
    {/if}

    {#if lead_or_boli_2 == 1}
      <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xxl-12" style="padding-top:10px">
        <MarketProgressReportTableNewLeads
          {months}
          mprt_countries_dict={table_leads_dict}
          mprt_basis_dict={table_leads_dict_basis}
          {laender_dict}
          {adressable_market_size_charts_dict}
          {marketing_start_date}
          bind:lead_or_boli={lead_or_boli_2}
        />
      </div>
    {/if}

    {#if lead_or_boli_2 == 2}
      <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xxl-12" style="padding-top:10px;">
        {#if market_progress_rep_table_active_boli_basis}
          <MarketProgressReportTableActiveBoli
            {months}
            mprt_countries_dict={active_animals_table_values}
            mprt_basis_dict={active_boli_basis_per_country}
            {laender_dict}
            {adressable_market_size_charts_dict}
            bind:lead_or_boli={lead_or_boli_2}
          />
        {/if}
      </div>
    {/if}
  </div>
</main>

<style>
  .green-border {
    /*background-color: #fbfcfc;*/
    border-width: 0.25px;
    border-style: solid;
    border-color: #afc5b9 !important;
  }

  .month-year {
    width: 100px;
    border: grey 0.25pt solid;
    border-radius: 5px;
    font-size: 12px;
  }

  .trenner-links {
    border-left: 3px solid #d9d9d9;
  }

  .half {
    width: 50px;
  }

  .hiddenClassGaunt {
    visibility: hidden;
  }

  .hiddenClass {
    visibility: hidden;
    display: none;
  }
  .help {
    position: absolute;
    right: 0;
    top: 0;
    width: 22px;
    height: 15px;
    z-index: 100;
  }
  .funnel {
    max-width: 100%;
  }

  .funnelParentNumbers {
    display: flex;
    flex-direction: column;
  }

  .flex-2 {
    position: relative;
    flex: 1;
  }
  .flex-2-child {
    display: flex;
    align-items: stretch;
    height: 16.8%;
  }

  .gauge_boli {
    width: 100%;
  }

  #sold_more_then_boli {
    width: 50px;
    height: 20px;
    background: #268026;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  #current_boli {
    width: 50px;
    height: 20px;
    background: #fff04d;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  #should_be_here {
    width: 50px;
    height: 20px;
    background: #03fcf4;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  .reddiv {
    width: 50px;
    height: 20px;
    background: #990e05;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  .greendiv {
    width: 50px;
    height: 20px;
    background: #268026;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  .active {
    color: #333;
    border-color: #325cff;
  }

  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  main {
    /*background-color: #c5e0b4;*/
  }

  .info-box-auf-hoehe {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 12px;
    height: auto;
    width: 70%;
    margin-left: 20px;
    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: inherit;
    left: calc(var(--x) * 2);
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
    line-height: 130%;
  }

  .info-box {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 12px;
    height: auto;
    width: 600px;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: 50px;
    /*    top: 0;*/
    right: 50px;
    /*    left: 0;*/
    /*    transform: translate(calc(var(--x)), calc(var(--y)));*/
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
    line-height: 130%;
  }

  .info-box:hover .info-box {
    display: block;
  }

  .info-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    /*background-color: #eef3f0;*/
    border: 1px solid #999999;
    height: 25px;
    border-radius: 50%;
    width: 25px;
    text-align: center;
  }

  .info-circle:hover .info-box {
    display: block;
  }

  .info-circle:hover .info-i {
    display: none;
  }

  .hoverclass:hover .info-box {
    display: block;
  }

  .hoverclass:hover .info-i {
    display: none;
  }

  .info-box-auf-hoehe:hover .info-box-auf-hoehe {
    display: block;
  }

  .info-circle:hover .info-box-auf-hoehe {
    display: block;
  }

  .hoverclass:hover .info-box-auf-hoehe {
    display: block;
  }
</style>
